<div class="date-time-picker-container">
  
  <div class="date-time-picker-container__calendars">
    <div class="calendar-pane">
      <mat-calendar 
        class="no-header-controls start-calendar" 
        [selected]="selectedRange()"
        [ngClass]="{'single-date': !startDate() && endDate()}"
        (selectedChange)="onStartDateChange($event)">
        
      </mat-calendar>
    </div>
    <div class="vertical-divider"></div>
    <div class="calendar-pane">
      <mat-calendar 
        class="no-header-controls end-calendar" 
        [ngClass]="{'single-date': startDate() && !endDate()}"
        [selected]="selectedRange()"
        [minDate]="startDate()"
        (selectedChange)="onEndDateChange($event)">
      </mat-calendar>
    </div>
</div>

  <div class="horizontal-divider"></div>

  <div class="date-time-picker-container__time">
    
    <div class="time-pane">
      <div class="time-pane__header"><strong class="bold">{{ 'COM.DIALOGS.DATE_TIME_PICKER.FROM' | translate }}</strong> {{ startTime() }}</div>
      <div class="time-pane__inputs">
        <div class="time-control">
          <button class="arrow-btn" (click)="incrementHour(dateKindEnum.start)"><mat-icon>keyboard_arrow_up</mat-icon></button>
          <input type="text" [value]="startHour12()" class="time-input" readonly>
          <button class="arrow-btn" (click)="decrementHour(dateKindEnum.start)"><mat-icon>keyboard_arrow_down</mat-icon></button>
        </div>
        <span class="time-colon">:</span>
        <div class="time-control">
          <button class="arrow-btn" (click)="incrementMinuteByFrequency(dateKindEnum.start)"><mat-icon>keyboard_arrow_up</mat-icon></button>
          <input type="text" [value]="startMinute()" class="time-input" readonly>
          <button class="arrow-btn" (click)="decrementMinuteByFrequency(dateKindEnum.start)"><mat-icon>keyboard_arrow_down</mat-icon></button>
        </div>
      </div>
      <div class="am-pm-toggle">
        <button class="toggle-btn" [class.active]="startPeriod() === 'am'" (click)="startPeriod.set('am')">AM</button>
        <div class="am-pm-toggle__divider"></div>
        <button class="toggle-btn" [class.active]="startPeriod() === 'pm'" (click)="startPeriod.set('pm')">PM</button>
      </div>
    </div>

    <div class="vertical-divider"></div>

    <div class="time-pane">
      <div class="time-pane__header"><strong class="bold">{{ 'COM.DIALOGS.DATE_TIME_PICKER.TO' | translate }}</strong> {{ endTime() }}</div>
      <div class="time-pane__inputs">
        <div class="time-control">
          <button class="arrow-btn" (click)="incrementHour(dateKindEnum.end)"><mat-icon>keyboard_arrow_up</mat-icon></button>
          <input type="text" [value]="endHour12()" class="time-input" readonly>
          <button class="arrow-btn" (click)="decrementHour(dateKindEnum.end)"><mat-icon>keyboard_arrow_down</mat-icon></button>
        </div>
        <span class="time-colon">:</span>
        <div class="time-control">
          <button class="arrow-btn" (click)="incrementMinuteByFrequency(dateKindEnum.end)"><mat-icon>keyboard_arrow_up</mat-icon></button>
          <input type="text" [value]="endMinute()" class="time-input" readonly>
          <button class="arrow-btn" (click)="decrementMinuteByFrequency(dateKindEnum.end)"><mat-icon>keyboard_arrow_down</mat-icon></button>
        </div>
      </div>
      <div class="am-pm-toggle">
        <button class="toggle-btn" [class.active]="endPeriod() === 'am'" (click)="endPeriod.set('am')">AM</button>
        <div class="am-pm-toggle__divider"></div>
        <button class="toggle-btn" [class.active]="endPeriod() === 'pm'" (click)="endPeriod.set('pm')">PM</button>
      </div>
    </div>
  </div>

  <div class="horizontal-divider"></div>

  <div class="date-time-picker-container__actions">
    <button class="action-btn action-btn--cancel" (click)="cancel.emit()">{{ 'COM.DIALOGS.DATE_TIME_PICKER.CANCEL' | translate }}</button>
    <button class="action-btn action-btn--apply" [disabled]="disableApply()" (click)="onApplyClick()">{{ 'COM.DIALOGS.DATE_TIME_PICKER.APPLY' | translate }}</button>
  </div>

</div>